export const USER_IS_BLOCKED = 'USER_IS_BLOCKED/auth';
export const USER_SESSION_EXPIRED = 'USER_SESSION_EXPIRED/auth';
